import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs/Subscription';
import { AppMemoryService } from '../../core/app-memory.service';
import { GetService } from '../../core/get.service';
import { saRegionSc, saRegionSc24 } from '../../models/Regions';

@Component({
  selector: 'app-rule-book',
  templateUrl: './rule-book.component.html',
  styleUrls: ['./rule-book.component.less']
})
export class RuleBookComponent implements OnInit, OnDestroy {

  public pdfSrc = '';
  public banner: string = null;
  public ruleBook: Region;
  public regions: Region[] = [];
  public regionsSub: Subscription;
  public user: User;

  constructor(
    public appMemory: AppMemoryService,
    private getService: GetService
  ) { }

  async ngOnInit() {
    this.user = await this.getService.getUser();
    this.regionsSub = await this.appMemory.regions.subscribe(async (regions) => {
      if (regions) {
        regions.forEach(e => {
          e.text = e.name;
        });
        this.regions = regions;
      }
    });
    this.getPdf(this.user.organization.farms[0].region);
  }

  ngOnDestroy() {
    if (this.regionsSub) {
      this.regionsSub.unsubscribe();
    }
  }

  changeSelection(e) {
    this.ruleBook = e;
    this.getPdf(e.id);
  }

  getPdf(region: string) {
    if (region) {
      switch (region) {
        case saRegionSc:
          this.pdfSrc = environment.ruleBookSCPdf;
          this.banner = 'For more information about the Saudi Cup you can visit their website here: ' +
            '<a href=\'https://thesaudicup.com.sa/\' ' +
            'target=\'_blank\'>thesaudicup.com.sa</a>';
          break;

        case saRegionSc24:
          this.pdfSrc = environment.ruleBookSC24Pdf;
          this.banner = 'For more information about the Saudi Cup you can visit their website here: ' +
            '<a href=\'https://thesaudicup.com.sa/\' ' +
            'target=\'_blank\'>thesaudicup.com.sa</a>';
          break;
        default:
          this.pdfSrc = null;
      }
    } else {
      this.pdfSrc = environment.ruleBookPdf;
    }
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/rule-book/rule-book.component.ts